import { Injectable } from '@angular/core';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './simulated-flight.actions';
import * as fromSimulatedFlightQuery from './simulated-flight.selectors';
import { LoadApproachTypes } from '../posted-flight/posted-flight.actions';

@Injectable()
export class SimulatedFlightFacade {
  simulatedFlightSkeletonsLoading$ = this.store.pipe(
    select(fromSimulatedFlightQuery.getSimulatedFlightSkeletonLoading)
  );
  simulatedFlightSkeletonsLoaded$ = this.store.pipe(
    select(fromSimulatedFlightQuery.getSimulatedFlightSkeletonLoaded)
  );
  simulatedFlightSkeletons$ = this.store.pipe(
    select(fromSimulatedFlightQuery.getSimulatedFlightSkeletons)
  );

  simulatedFlightAuditLoading$ = this.store.pipe(
    select(fromSimulatedFlightQuery.getSimulatedFlightAuditLoading)
  );
  simulatedFlightAuditLoaded$ = this.store.pipe(
    select(fromSimulatedFlightQuery.getSimulatedFlightAuditLoaded)
  );
  simulatedFlightAudit$ = this.store.pipe(select(fromSimulatedFlightQuery.getSimulatedFlightAudit));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadSimulatedFlight() {
    this.store.dispatch(actions.ResetSimulatedFlight());
    this.store.dispatch(LoadApproachTypes());
    this.store.dispatch(actions.LoadSimulatedFlightSkeletons());
  }

  loadSimulatedFlightAudit(simulatedFlightId: number) {
    this.store.dispatch(actions.LoadSimulatedFlightAudit({ simulatedFlightId }));
  }

  loadNextSimulatedFlightAuditPage(simulatedFlightId: number) {
    this.store.dispatch(actions.LoadNextPageSimulatedFlightAudit({ simulatedFlightId }));
  }
}
